import type { RoomVote } from '../useRoomControl';

interface Props {
  vote: RoomVote;
  counts: number[];
  myVote: number | null;
  isHost: boolean;
  onVote: (index: number) => void;
  onClose: () => void;
}

/** Carte flottante de sondage : visible par tous, votable en direct. */
export default function VotePanel({ vote, counts, myVote, isHost, onVote, onClose }: Props) {
  const total = counts.reduce((a, b) => a + b, 0);
  return (
    <div className="w-[320px] max-w-[calc(100vw-2rem)] bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-200/70">
        <div className="flex items-center gap-2 min-w-0">
          <i className="ri-bar-chart-2-line text-accent-500"></i>
          <span className="text-sm font-semibold text-foreground-900 truncate">Sondage</span>
        </div>
        {isHost && (
          <button onClick={onClose} className="w-7 h-7 rounded-full flex items-center justify-center text-foreground-400 hover:bg-background-100 cursor-pointer" title="Clôturer le sondage">
            <i className="ri-close-line"></i>
          </button>
        )}
      </div>
      <div className="p-4">
        <p className="text-sm font-medium text-foreground-800 mb-3 leading-snug">{vote.question}</p>
        <div className="space-y-2">
          {vote.options.map((opt, i) => {
            const pct = total > 0 ? Math.round((counts[i] / total) * 100) : 0;
            const chosen = myVote === i;
            return (
              <button
                key={i}
                onClick={() => vote.open && onVote(i)}
                disabled={!vote.open}
                className={`relative w-full text-left px-3 py-2.5 rounded-lg border overflow-hidden cursor-pointer transition-colors ${
                  chosen ? 'border-accent-400 bg-accent-50' : 'border-background-200/70 hover:bg-background-100'
                } ${!vote.open ? 'cursor-default' : ''}`}
              >
                <span className="absolute inset-y-0 left-0 bg-accent-500/15" style={{ width: `${pct}%` }}></span>
                <span className="relative flex items-center justify-between gap-2">
                  <span className="text-sm text-foreground-800 truncate">{opt}</span>
                  <span className="text-xs font-semibold text-foreground-600 tabular-nums">{pct}%</span>
                </span>
              </button>
            );
          })}
        </div>
        <p className="text-[11px] text-foreground-400 mt-3">
          {vote.open ? `${total} vote${total !== 1 ? 's' : ''} · votez maintenant` : 'Sondage clôturé'}
        </p>
      </div>
    </div>
  );
}